import React from 'react';
import { TooltipBtn } from '../../../../components/TooltipBtn';
import { useStyleContextState } from '../../../styleContext';
import { HeaderGeneralLanguagesList } from './HeaderGeneralLanguagesList';
import { AngleDownSmall } from '../../../../components/Icons/AngleDownSmall';
import { isMobile } from '../../../../utils/device';
import classes from './styles/index.module.scss';

const TooltipLanguages = ({ languages }) => (
	<div className={classes.languagesTooltip}>
		<HeaderGeneralLanguagesList languages={languages} />
	</div>
);

const HeaderGeneralLanguages = ({ isLoginPage }) => {
	const { languages } = useStyleContextState();
	const activeLanguage = languages.find((x) => x.isActive);

	if (!activeLanguage || languages.length <= 1) {
		return null;
	}

	return (
		<>
			<TooltipBtn
				tooltip={<TooltipLanguages languages={languages} />}
				tooltipPosition='bottom'
				tooltipAlign='end'
			>
				<span className={classes.activeLanguage}>
					<img
						className={classes.activeLanguage_img}
						src={activeLanguage.icon}
						alt={activeLanguage.name}
					/>
					{(!isMobile || isLoginPage) && (
						<span className={classes.activeLanguageName}> {activeLanguage.name} </span>
					)}
					<AngleDownSmall />
				</span>
			</TooltipBtn>
		</>
	);
};

export default HeaderGeneralLanguages;
